// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".codeMarker {\n    background: coral;\n    position: absolute;\n    z-index: 20;\n}", ""]);
// Exports
module.exports = exports;
